module.exports = __webpack_public_path__ + "static/media/5.51356088.jpg";